"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var withWidth_1 = require("@material-ui/core/withWidth");
var ResponsiveImgMaterialUi = function (props) { return (React.createElement("img", { id: props.id, src: getSrc(props), style: props.style })); };
var getSrc = function (props) {
    switch (props.width) {
        case 'xl':
            if (!!props.xl) {
                consoleDebug(props.debug, props.width, 'xl');
                return props.xl;
            }
        case 'lg':
            if (!!props.lg) {
                consoleDebug(props.debug, props.width, 'lg');
                return props.lg;
            }
        case 'md':
            if (!!props.md) {
                consoleDebug(props.debug, props.width, 'md');
                return props.md;
            }
        case 'sm':
            if (!!props.sm) {
                consoleDebug(props.debug, props.width, 'sm');
                return props.sm;
            }
        case 'xs':
        default:
            if (!!props.xs) {
                consoleDebug(props.debug, props.width, 'xs');
                return props.xs;
            }
            consoleDebug(props.debug, props.width, 'none');
    }
};
var consoleDebug = function (debug, windowWidth, appliedWidth) {
    if (debug) {
        console.debug('ResponsiveImgMaterialUiProps', { windowWidth: windowWidth, appliedWidth: appliedWidth });
    }
};
exports.default = withWidth_1.default()(ResponsiveImgMaterialUi);
//# sourceMappingURL=ResponsiveImgMaterialUi.js.map